export const speakers = [
    {
        image: require("../../assets/images/speakers/microsoft.png"),
        name: "Microsoft",
        title: "",
        company: "",
        socialLinks: []
    },
    {
        name: "Rashmi Misra",
        title: "General Manager, Data and AI Business Development",
        company: "Microsoft",
        image: require("../../assets/images/speakers/misra.png"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/rmisra11" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/rmisra/" }
        ]
    },
    {
        image: require("../../assets/images/speakers/jason_wei.jpeg"),
        name: "Jason Wei",
        title: "AI Researcher",
        company: "OpenAI",
        socialLinks: [
            { href: "https://twitter.com/_jasonwei", icon: "icofont-twitter" },
            { href: "https://www.linkedin.com/in/jason-wei-5a7323b0/", icon: "icofont-linkedin" },
            { href: "https://www.jasonwei.net/", icon: "icofont-web" }
        ]
    },
      {
        image: require("../../assets/images/speakers/harrison.jpeg"),
        name: "Harrison Chase",
        title: "CEO",
        company: "LangChain",
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/hwchase17" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/harrison-chase-961287118/" }
        ]
    },
    {
        image: require("../../assets/images/speakers/arvind_jain.jpg"),
        name: "Arvind Jain",
        title: "CEO",
        company: "Glean",
        socialLinks: [
            { href: "https://twitter.com/jainarvind", icon: "icofont-twitter" },
            { href: "https://www.linkedin.com/in/arvind-jain-5935161/", icon: "icofont-linkedin" },
            { href: "https://www.glean.com/", icon: "icofont-web" }
        ]
    },

    {
        image: require("../../assets/images/speakers/jason_l.webp"),
        name: "Jason Lopatecki",
        title: "CEO",
        company: "Arize AI",
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/jason_lopatecki" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/jason-lopatecki-9509941/" }
        ]
    },
    {
        name: "Worldcoin",
        title: "",
        company: "",
        image: require("../../assets/images/speakers/worldcoin.png"),
        socialLinks: [
            { icon: "icofont-web", href: "https://worldcoin.org/world-id" },
            { icon: "icofont-twitter", href: "https://twitter.com/worldcoin" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/company/worldcoinfoundation/" }
        ]
    },
    {
        name: "Aravind Srinivas",
        title: "Cofounder & CEO",
        company: "Perplexity AI",
        image: require("../../assets/images/speakers/arvind.jpeg"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/AravSrinivas" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/aravind-srinivas-16051987/" }
        ]
    },
    {
        name: "Anton Troynikov",
        title: "Founder",
        company: "Chroma",
        image: require("../../assets/images/speakers/anton.jpg"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/atroyn" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/antontroynikov/" }
        ]
    },
    {
        name: "Rajat Suri",
        title: "Co-founder @Lima Founder @Presto",
        company: "Co-founder @Lyft",
        image: require("../../assets/images/speakers/rajat.jpg"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/rajatsuri" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/rajatsuri/" }
        ]
    },
    {
        name: "Jonathan Heyne",
        title: "COO",
        company: "DeepLearning.AI",
        image: require("../../assets/images/speakers/jonathan.jpg"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/Jonheyne" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/jonathanheyne/" }
        ]
    },
    {
        name: "Kian Katanforoosh",
        title: "CEO & Founder",
        company: "Workera",
        image: require("../../assets/images/speakers/kian.jpg"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/kiankatan" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/kiankatan/" }
        ]
    },
    
    {
        name: "Jerry Liu",
        title: "Cofounder & CEO",
        company: "LlamaIndex",
        image: require("../../assets/images/speakers/jerryliu.jpeg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://jerryjliu.github.io/" },
            { icon: "icofont-twitter", href: "https://twitter.com/jerryjliu0" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/jerry-liu-64390071/" }
        ]
    },
    {
        name: "Amin Ahmad",
        title: "Founder & CTO",
        company: "Vectara",
        image: require("../../assets/images/speakers/amin.jpg"),
        socialLinks: [
            
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/aminahmad/" }
           
        ]
    },
    {
        name: "Jay Alammar",
        title: "Director, Engineering Fellow",
        company: "Cohere",
        image: require("../../assets/images/speakers/Jay.jpg"),
        socialLinks: [
            { icon: "icofont-web", href: "http://jalammar.github.io/" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/jalammar/recent-activity/all/" },
            { icon: "icofont-twitter", href: "https://twitter.com/JayAlammar" }
        ]
    },
    {
        name: "Ameer Haj-Ali",
        title: "Head of Cloud Infrastructure & Platform Engineering",
        company: "Anyscale",
        image: require("../../assets/images/speakers/ameer.jpg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://www.ameerhajali.com/" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/ameer-haj-ali/" }
        ]
    },
    {
        name: "Yun Jin",
        title: "Engineering Director",
        company: "Meta",
        image: require("../../assets/images/speakers/yunjin.jpg"),
        socialLinks: [
            
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/yunjin/" },
            
        ]
    },
    {
        name: "Yan Zhao",
        title: "Vice Mayor",
        company: "City of Saratoga",
        image: require("../../assets/images/speakers/zhaoyan.jpg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://www.saratoga.ca.us/443/Yan-Zhao" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/yan-zhao-92a3328/" },
        ]
    },
    {
        name: "Xinyun Chen",
        title: "Senior Scientist",
        company: "Google Deepmind",
        image: require("../../assets/images/speakers/xinyun.jpeg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://jungyhuk.github.io/" },
            { icon: "icofont-twitter", href: "https://twitter.com/xinyun_chen_" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/xinyun-chen-b4ab79172/" }
        ]
    },

    {
        name: "Hanyu Xue",
        title: "Principle ML Eng Mgr",
        company: "Microsoft",
        image: require("../../assets/images/speakers/hanyu.jpeg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/hanyu-xue-34325590/" }
        ]
    },
    {
        name: "Yichong Xu",
        title: "AI Researcher",
        company: "Character.AI",
        image: require("../../assets/images/speakers/yichong.jpg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://xycking.wixsite.com/yichongxu" },
            { icon: "icofont-twitter", href: "https://twitter.com/xycking" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/yichong-xu-46618383/" }
        ]
    },
    {
        image: require("../../assets/images/speakers/yangqingjia.jpeg"),
        name: "Yangqing Jia",
        title: "Founder",
        company: "Lepton AI",
        socialLinks: [
            { href: "https://twitter.com/jiayq", icon: "icofont-twitter" },
            { href: "https://www.linkedin.com/in/yangqing-jia/", icon: "icofont-linkedin" },
            { href: "https://daggerfs.com/", icon: "icofont-web" }
        ]
    },
    {
        name: "Li Erran Li",
        title: "Head of HIL Science",
        company: "AWS",
        image: require("../../assets/images/speakers/erran.png"),
        socialLinks: [
            { icon: "icofont-web", href: "http://www.cs.columbia.edu/~lierranli/ " },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/li-erran-li-552aa217/" }
        ]
    },
    {
        name: "Lianmin Zheng",
        title: "Author of Vicuna",
        company: "UCB LMSYS AI Lab",
        image: require("../../assets/images/speakers/lianmin.png"),
        socialLinks: [
            { icon: "icofont-web", href: "https://lmzheng.net/" },
            { icon: "icofont-twitter", href: "https://twitter.com/lm_zheng" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/lianmin-zheng-6266a8114" }
        ]
    },
    {
        name: "Shishir Patil",
        title: "Creator",
        company: "Gorilla LLM",
        image: require("../../assets/images/speakers/patil.jpg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://shishirpatil.github.io/" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/shishir-patil/" },
            { icon: "icofont-twitter", href: "https://twitter.com/shishirpatil_" }
        ]
    },
    {
        name: "Michael Jung",
        title: "Founder",
        company: "DeepBrain AI",
        image: require("../../assets/images/speakers/jung.jpeg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/msjung/" }
        ]
    },
    {
        name: "Shaun Wei",
        title: "Founder & CEO",
        company: "RealChar.",
        image: require("../../assets/images/speakers/shaun.JPG"),
        socialLinks: [
            { icon: "icofont-twitter", href: "https://twitter.com/agishaun" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/shaunwei/" }
        ]
    },
    // {
    //     name: "Murray Newlands",
    //     title: "Investor",
    //     company: "Open Future Technology",
    //     image: require("../../assets/images/speakers/newlands.jpg"),
    //     socialLinks: [
    //         { icon: "icofont-web", href: "https://www.murraynewlands.com/" },
    //         { icon: "icofont-twitter", href: "https://twitter.com/MurrayNewlands" },
    //         { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/murraynewlands/" }
    //     ]
    // },
    {
        name: "Karina Nguyen",
        title: "AI Researcher",
        company: "Anthropic",
        image: require("../../assets/images/speakers/nguyen.png"),
        socialLinks: [
            { icon: "icofont-web", href: "https://karinanguyen.com/" },
            { icon: "icofont-twitter", href: "https://twitter.com/karinanguyen_" }
        ]
    },
    {
        name: "Chunting Zhou",
        title: "Research Scientist",
        company: "Meta AI",
        image: require("../../assets/images/speakers/chuntingzhou.jpeg"),
        socialLinks: [
            { icon: "icofont-web", href: "https://violet-zct.github.io" },
            { icon: "icofont-twitter", href: "https://twitter.com/violet_zct" },
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/chunting-zhou-14525985" }
        ]
    },
    {
        name: "Tiger Feng",
        title: "President",
        company: "Seattle Technical Forum",
        image: require("../../assets/images/speakers/tiger.png"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/tigerf/" }
        ]
    }
    ,
    {
        name: "Rohit Agarwal",
        title: "Co-Founder & CEO",
        company: "Portkey.AI",
        image: require("../../assets/images/speakers/Rohit.jpg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/1rohitagarwal/" }
        ]
    },
    {
        name: "Shawn Wang",
        title: "Founder",
        company: "Smol AI",
        image: require("../../assets/images/speakers/Shawn.png"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/shawnswyxwang/" }
            
        ]
    },
    {
        name: "Florence Li",
        title: "Chief Creative Officer",
        company: "MetaY",
        image: require("../../assets/images/speakers/Florence.jpg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/florence-li-18b657206/" }
           
        ]
    }
    ,
    {
        name: "Michael Ran",
        title: "Co-Founder",
        company: "GPTDAO & Dawn Lab & 1gen.AI",
        image: require("../../assets/images/speakers/MichaelRan.jpg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/yang-ran-4ab4357a/" }
            ,{ icon: "icofont-twitter", href: "https://twitter.com/MichaelRan15" }

            
        ]
    }
    ,
    {
        name: "Alan Xing",
        title: "Co-Founder",
        company: "GPT DAO & Wagmi33 Foundation",
        image: require("../../assets/images/speakers/Alan.jpg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/alanxing/" }
            ,{ icon: "icofont-twitter", href: "https://twitter.com/alanxing" }
            
        ]
    }
    ,
    {
        name: "Ziren Lin",
        title: "Senior Data Scientist",
        company: "McKinsey AI",
        image: require("../../assets/images/speakers/ziren.jpg"),
        socialLinks: [
            { icon: "icofont-linkedin", href: "https://www.linkedin.com/in/ziren-lin-62bb5a11a/" }
            ,{ icon: "icofont-twitter", href: "https://twitter.com/lin_ziren" }
        ]

    }
    
];
